'use client';

import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useFaqScroll } from '@/hooks/useFaqScroll';
import { generateFaqSlug } from '@/utils/slugify';

export const RepaymentQuestions = ({ repaymentFaqInitialData }) => {
  const { openSection, toggleSection, setItem } = useFaqScroll(
    repaymentFaqInitialData?.data || [],
    generateFaqSlug
  );

  return (
    <div className="lg:flex lg:flex-col">
      <h2 className="text-3xl md:text-4xl text-[#373945] font-semibold mb-8">
        Repayment questions
      </h2>

      {/* Faq Section */}
      {repaymentFaqInitialData?.data && Array.isArray(repaymentFaqInitialData.data)
        && repaymentFaqInitialData.data.length > 0
        && repaymentFaqInitialData.data.map((faq, index) => (
          <div
            key={index}
            ref={setItem(index)}
            className="pt-8 pb-8 last:pb-0 pr-1 pl-1 border-[#CBCDD6] border-t"
          >
            <button
              onClick={() => toggleSection(index)}
              className="flex items-center justify-between w-full"
            >
              <div className="text-left text-lg font-semibold lg:text-2xl text-[#373945] w-[16rem] md:w-[35rem] lg:w-[50rem] xl:w-[65rem]"
                dangerouslySetInnerHTML={{ __html: faq?.faq_title }}>
              </div>
              {openSection === index ? (
                <ChevronUp
                  className="h-5 w-5"
                  style={{ color: '#373945' }}
                />
              ) : (
                <ChevronDown
                  className="h-5 w-5"
                  style={{ color: '#373945' }}
                />
              )}
            </button>
            <div className={`${openSection === index ? 'block' : 'hidden'}`}>
              <div className="flex items-start mt-4 gap-2">
                <div className="text-[#373945] text-base font-450 w-[18rem] md:w-[40rem] lg:w-[55rem] xl:w-[65rem]"
                  dangerouslySetInnerHTML={{ __html: faq?.faq_content }}>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
